import { render, staticRenderFns } from "./TagsListRemove.vue?vue&type=template&id=d49cfefc&scoped=true&"
import script from "./TagsListRemove.vue?vue&type=script&lang=js&"
export * from "./TagsListRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49cfefc",
  null
  
)

export default component.exports